
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples/search",
      function () {
        return require("private-next-pages/examples/search.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples/search"])
      });
    }
  